import { getCartId, setCartId } from '@helper_cartid';
import { getLoginInfo } from '@helper_auth';
import * as ActionSchema from '@core_modules/product/services/graphql/actionSchema';

const internalContext = {
    context: {
        request: 'internal',
    },
};

const ensureCartId = async (client) => {
    const existingCartId = getCartId();
    if (existingCartId) {
        return existingCartId;
    }

    const isLogin = getLoginInfo();
    let cartId = '';

    if (!isLogin) {
        const res = await client.mutate({
            mutation: ActionSchema.createCartIdGuest,
            ...internalContext,
        });
        cartId = res?.data?.createEmptyCart || '';
    } else {
        const res = await client.query({
            query: ActionSchema.getCartIdUser,
            fetchPolicy: 'no-cache',
            ...internalContext,
        });
        cartId = res?.data?.customerCart?.id || '';
    }

    if (cartId) {
        setCartId(cartId);
    }

    return cartId;
};

export default ensureCartId;
